module.exports = __webpack_public_path__ + "img/bgcenter.ceed31b9.png";